var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gridItem"},[_c('span',[_vm._v(_vm._s(_vm.t("tokens")))]),_c('span',{class:_vm.tokenClassColor},[_vm._v(_vm._s(_vm.t("tokensLeft", { tokens: _vm.tokens })))])])}
var staticRenderFns = []

export { render, staticRenderFns }